import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEenCamerasMutationVariables = Types.Exact<{
  input: Types.EenGetCamerasInput;
}>;


export type GetEenCamerasMutation = { __typename?: 'mutation_root', een_get_cameras?: { __typename?: 'EenGetCamerasOutput', data: string } | null };


export const GetEenCamerasDocument = gql`
    mutation getEenCameras($input: EenGetCamerasInput!) {
  een_get_cameras(input: $input) {
    data
  }
}
    `;
export type GetEenCamerasMutationFn = Apollo.MutationFunction<GetEenCamerasMutation, GetEenCamerasMutationVariables>;

/**
 * __useGetEenCamerasMutation__
 *
 * To run a mutation, you first call `useGetEenCamerasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEenCamerasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEenCamerasMutation, { data, loading, error }] = useGetEenCamerasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEenCamerasMutation(baseOptions?: Apollo.MutationHookOptions<GetEenCamerasMutation, GetEenCamerasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEenCamerasMutation, GetEenCamerasMutationVariables>(GetEenCamerasDocument, options);
      }
export type GetEenCamerasMutationHookResult = ReturnType<typeof useGetEenCamerasMutation>;
export type GetEenCamerasMutationResult = Apollo.MutationResult<GetEenCamerasMutation>;
export type GetEenCamerasMutationOptions = Apollo.BaseMutationOptions<GetEenCamerasMutation, GetEenCamerasMutationVariables>;